import React, { useState } from 'react';
import { Button, MessagePlugin } from 'tdesign-react';
import { updateAutoAll } from '@/services/resourceService';

/**
 * 自动更新全部版本
 *
 * @typedef {Object} Props
 * @property {string} componentStencilId - 组件样板的ID。
 * @property {number} [envId=0] - 环境的ID（默认值：0）。
 * @property {number} [clusterId=0] - 集群的ID（默认值：0）。
 * @property {number} [productLibId] - 制品库的ID。
 * @property {function} onFinish - 更新完成时调用的回调函数。
 * @return {JSX.Element} 渲染的组件。
 */
export default function AutoUpdateAllVersion({
  componentStencilId,
  envId = 0,
  clusterId = 0,
  productLibId,
  onFinish,
}) {
  const [loading, setLoading] = useState(false);

  const doUpdate = async () => {
    try {
      setLoading(true);
      await updateAutoAll({
        componentStencilId,
        envId,
        clusterId,
        productLibId,
      });
      MessagePlugin.success('操作成功');
      onFinish();
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button loading={loading} theme='primary' onClick={doUpdate}>
      自动更新全部版本
    </Button>
  );
}
